import _ from 'lodash'
import React from 'react'
import ScrollSpy from '../../../layouts/scrollspy'
import ListingBadge, { BADGE_ORDER_PRIORITY, BADGE_MODE } from './base'
import FullWidthBadge from './fullWidthBadge'

class CashOnlyBadge extends ListingBadge {
  static title = 'Cash Only'

  static titleIcon = 'money-bill'

  static contentPositive = false

  static shouldBeIncluded(listing, badgeMode) {
    // only applies to expanded, hide for condensed
    return (
      badgeMode === BADGE_MODE.EXPANDED &&
      !_.get(listing, 'listing_configuration.financing_available', false)
    )
  }

  get content() {
    const trustee = _.get(this.props.listing, 'event.trustee_sale', false)
    return (
      <>
        Conventional financing is <strong>NOT</strong> accepted for this
        property.{' '}
        <ScrollSpy selector='#prepare_your_finances'>
          {({ scrollTo }) => (
            <a onClick={scrollTo}>
              {trustee ? 'What should I bring?' : 'Learn more'}
            </a>
          )}
        </ScrollSpy>
      </>
    )
  }
}

class FinancingAvailableBadge extends FullWidthBadge {
  static summary = 'Eligible for Financing'

  static titleIcon = 'money-bill'

  static condensedTitle = 'Financing Available'

  static renderPriority = BADGE_ORDER_PRIORITY.FIFTH

  static shouldBeHoisted = true

  static shouldBeIncluded(listing) {
    // applies to all modes
    return _.get(listing, 'listing_configuration.financing_available', false)
  }

  get content() {
    return (
      <>
        Buyers are responsible for determining financing eligibility prior to
        bidding.{' '}
        <ScrollSpy selector='#prepare_your_finances'>
          {({ scrollTo }) => <a onClick={scrollTo}>Learn More</a>}
        </ScrollSpy>
      </>
    )
  }
}

export { CashOnlyBadge, FinancingAvailableBadge }
